import { ColorValueStrict } from 'fronton-react';
import { css } from 'linaria';
import { styled } from 'linaria/react';

export type StylesSectionProps = {
  bgColor: ColorValueStrict | string;
};

export const StyledSection = styled.section<StylesSectionProps>`
  width: 100%;
  overflow: hidden;
  background-color: ${({ bgColor }: StylesSectionProps) => bgColor};

  @media (--from-desktop) {
    height: 480px;
  }
`;

export const headerSectionContainer = css`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  padding: 0;

  @media (--to-desktop) {
    flex-direction: column;
    width: 100%;
  }
`;

export const headerSectionTextContainer = css`
  @media (--to-desktop) {
    z-index: 2;
    order: 2;
  }
`;

export const headerSectionText = css`
  width: 473px;

  @media (--only-desktop) {
    width: 442px;
  }

  @media (--to-desktop) {
    width: 100%;
    padding: 40px 0;
  }
`;

export const headerSectionTitle = css`
  && {
    margin-bottom: 16px;
    white-space: break-spaces;
  }
`;

export const headerSectionDescription = css`
  && {
    white-space: break-spaces;

    @media (--only-mobile) {
      line-height: 24px;
    }
  }
`;

export const headerSectionImage = css`
  position: absolute;
  top: 0;
  left: 520px;
  width: 768px;
  height: 480px;
  object-fit: cover;

  @media (--only-desktop) {
    left: calc(486px + var(--fronton-layout-gutter));
    width: 496px;
  }

  @media (--to-desktop) {
    position: relative;
    left: 0;
    width: 100vw;
    height: 100%;
  }
`;

export const headerSectionPatternDesktop = css`
  position: absolute;
  left: 520px;
  z-index: 3;

  @media (--to-desktop) {
    display: none;
  }
`;

export const headerSectionPatternTablet = css`
  display: none;

  @media (--only-tablet) {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const headerSectionPatternMobile = css`
  display: none;

  @media (--only-mobile) {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const headerSectionButton = css`
  && {
    margin-top: 32px;

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
